/**
 * Comments API - Normalization Helpers
 *
 * Exported so repliesApi.js can reuse them without duplication.
 */

/**
 * Coerces any timestamp shape into a plain JS Date.
 * Handles: Firestore Timestamp, JS Date, ISO string, Unix number.
 */
export const normalizeTimestamp = (ts) => {
  if (!ts) return new Date();
  if (ts instanceof Date) return ts;
  if (typeof ts.toDate === "function") return ts.toDate();
  const d = new Date(ts);
  return isNaN(d.getTime()) ? new Date() : d;
};

/**
 * Extracts the display-name fields from a Firestore document's data object.
 */
export const normalizeUserData = (
  data,
  defaultUsername = "User",
  defaultProfession = "",
) => ({
  username: data.username || data.displayName || data.name || defaultUsername,
  profession: data.userProfession || data.profession || defaultProfession,
  photoURL: data.userPhotoURL || data.photoURL || "",
});

/**
 * Picks the first non-empty content field from a Firestore document.
 */
export const normalizeContentField = (data) =>
  data.text || data.content || data.description || "";
